import md5 from "blueimp-md5";
import IGameAPI, { PrizeResults, RetryCountResponse, SpinResults } from "./IGameAPI";

export default class GameAPI implements IGameAPI {
    private _gameInfo: any;

    constructor(private apiUrl: string, private customerId?: string) {
    }

    public async init() {
        this._gameInfo = await this.fetchGameInfo();
        console.log("Game info", this._gameInfo);

        if (!this.customerId) {
            const customerInfo = await this.fetchCustomerInfo();
            console.log("Customer info", customerInfo);

            this.customerId = customerInfo.content.id;
            console.log("Customer ID retrieved:", this.customerId);
        }
        else {
            console.log("Customer ID passed explicitly, skipped customer ID fetch from the API:", this.customerId);
        }
    }

    public get gameInfo(): any {
        return this._gameInfo;
    }

    public async fetchPrizes(): Promise<PrizeResults> {

        const ts = "" + Date.now();
        const hash = this.generateHash(ts);
        const response = await fetch(`${this.apiUrl}/v3/games/fortune20/prizes/?customer_id=${this.customerId}&hash=${hash}&ts=${ts}`, {
            method: 'GET',
            credentials: 'include',
            referrerPolicy: 'unsafe-url',
            headers: {
                'Content-Type': 'application/json',
            }
        });

        const body = await response.json();

        const prizesResult = <PrizeResults>body.content;

        prizesResult.prizes.forEach(prize => {

            if (!prize.description || prize.description === "") {
                const name = prize.name;
                prize.description = name;
                prize.name = (name.length > 10) ? name.substr(0, 9) + "..:" : name
            }
        });

        return prizesResult;
    }

    public async fetchRetryCount(): Promise<RetryCountResponse> {
        const ts = "" + Date.now();
        const hash = this.generateHash(ts);
        const response = await fetch(`${this.apiUrl}/v3/games/fortune20/tries-count/?customer_id=${this.customerId}&hash=${hash}&ts=${ts}`, {
            method: 'GET',
            credentials: 'include',
            referrerPolicy: 'unsafe-url',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        const body = await response.json();
        // console.log("getRetryCount: ", body);
        return body.content;
    }

    public async postSpin(): Promise<SpinResults> {
        const ts = "" + Date.now();
        const hash = this.generateHash(ts);
        const response = await fetch(`${this.apiUrl}/v3/games/fortune20/action/`, {
            method: 'POST',
            credentials: 'include',
            referrerPolicy: 'unsafe-url',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: `customer_id=${this.customerId}&hash=${hash}&ts=${ts}`
        });
        const body = await response.json();
        console.log("getSpinResult: ", body);
        return body.content;
    }

    private async fetchGameInfo() {
        const response = await fetch(`${this.apiUrl}/v6/content/pages/fortune20/`, {
            method: 'GET',
            credentials: 'include',
            referrerPolicy: 'unsafe-url',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return await response.json();
    }

    private async fetchCustomerInfo() {
        const response = await fetch(`${this.apiUrl}/v6/customers/`, {
            method: 'GET',
            credentials: 'include',
            referrerPolicy: 'unsafe-url',
            headers: {
                'Content-Type': 'application/json',
            }
        });
        const body = await response.json();
        return body;
    }


    private generateHash(ts?: string): string {
        const salt = 'iudv387g4837gcbbcsb83bibclcs8d7c';
        const tsString = "" + (ts || "");
        let check_string = this.customerId + tsString;
        for (let i = 0; i < 6; i++) {
            check_string += salt;
            check_string = md5(check_string);
        }
        return check_string;
    }
}

